module.exports = __webpack_public_path__ + "img/5.8575ec20.png";